import { useColors } from '@osmosis/react-ui/hooks/useColors';
import { useIntl } from 'react-intl';
import { DnDList } from '../dnd/DnDList';
import { DnDListProps } from '../dnd/types';

/**
 * QuizDnd.
 */
export const QuizDndList = (props: DnDListProps) => {
  const color = useColors();
  const intl = useIntl();

  const dropText = intl.formatMessage({
    id: 'quiz.dnd.list.placeholder',
    defaultMessage: 'Drop Here',
  });

  return (
    <DnDList
      styles={{
        sx: {
          justifyContent: 'center',
        },
        containerWrapperSx: {
          minWidth: 'auto',
          ':first-child': {
            mr: '15px',
          },
        },
        containerHeaderSx: {
          pb: '16px',
        },
        containerSx: {
          border: `1px solid ${color.gray20}`,
          borderRadius: '5px',
          width: '250px',
          minHeight: '400px',
          // maxHeight: '600px',
          overflow: 'auto',
          position: 'relative',
          height: 'auto',
        },
        listsSx: {
          padding: 0,
          height: '100%',
          ':after': {
            content: `'${dropText}'`,
            color: color.gray30,
            position: 'absolute',
            left: 'calc(50% - 25px)',
            top: 'calc(50% + 10px)',
          },
          ':before': {
            content: "''",
            background:
              'url(https://d3cdo0emj8d2qc.cloudfront.net/assets/Ua3zVM-9T7Sjj_lgjr1M0JttTbewOS5Y.png)',
            backgroundSize: '100%',
            width: '50px',
            height: '50px',
            display: 'flex',
            position: 'absolute',
            left: 'calc(50% - 25px)',
            top: 'calc(50% - 60px)',
          },
        },
        itemSx: {
          listStyle: 'none',
          borderBottom: `1px solid ${color.gray20}`,
          padding: '10px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: color.white,
        },
        itemOrderedSx: { marginRight: '10px', fontWeight: 'bold' },
        itemDraggedSx: {
          boxShadow: `4px 4px 3px 0px ${color.gray20}`,
          transform: 'scale(1.1)',
        },
      }}
      {...props}
    />
  );
};
